module.exports = __webpack_public_path__ + "img/battle_section3_item4.774f5fdf.png";